<template>
  <v-row class="pt-0 pb-1 px-2" justify="center">
    <!-- TOP BLOCKS -->
    <template v-for="(item, key) in topBlocks">
      <v-col class="pr-1 pl-1 pt-5 pb-5 d-flex" cols="12" sm="6" md="3" :key="`topblock-${key}`">
        <v-card
          :id="item.id"
          color="blocks_line"
          hover
          :to="item.link"
          class="flex-grow-1 rounded-lg"
          elevation="1"
          outlined
        >
          <v-row align="center">
            <v-col cols="12">
              <v-card-title primary-title>
                <v-row no-gutters>
                  <div>
                    <span class="headline">
                      {{ item.title }}
                    </span>
                    <p />
                  </div>
                  <v-spacer />
                  <span>
                    <v-icon large>
                      {{ item.icon }}
                    </v-icon>
                  </span>
                </v-row>
              </v-card-title>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
    topBlocks () {
      return [
        {
          title: this.$tc('my_permission', 2),
          icon: 'thumb_up_alt',
          link: { name: 'profile', query: { tab: 'permissions' } },
          id: 'profile_permissions'
        },
        {
          title: this.$tc('my_partition'),
          icon: 'view_module',
          link: { name: 'partition-keys' },
          id: 'partition_keys_block'
        },
        {
          title: this.$tc('my_attribute', 2),
          icon: 'info',
          link: { name: 'profile', query: { tab: 'attributes' } },
          id: 'profile_attributes'
        },
        {
          title: this.$tc('change_password'),
          icon: 'lock',
          link: { name: 'profile', query: { tab: 'change-password' } },
          id: 'profile_change_password'
        }
      ]
    }
  }
}
</script>
